import type { PaymentMethod } from '@/types';

export type PaymentChannelAction =
  | { type: 'none' }
  | { type: 'redirect'; url: string }
  | { type: 'submit-form'; html: string }
  | { type: 'qr'; value: string };

export const resolvePaymentChannelAction = (
  channelReturnBody: string,
  method: PaymentMethod,
): PaymentChannelAction => {
  const body = channelReturnBody.trim();
  if (!body) return { type: 'none' };
  if (body.includes('<form')) return { type: 'submit-form', html: body };

  try {
    const parsed = JSON.parse(body) as Record<string, unknown>;
    const payInfo =
      parsed.payInfo && typeof parsed.payInfo === 'object'
        ? (parsed.payInfo as Record<string, unknown>)
        : {};
    const qrValue = String(
      parsed.codeUrl ||
        parsed.code_url ||
        parsed.qrCodeUrl ||
        parsed.qr_code_url ||
        payInfo.codeUrl ||
        payInfo.code_url ||
        payInfo.qrCodeUrl ||
        payInfo.qr_code_url ||
        '',
    ).trim();
    const paymentUrl = String(
      parsed.webUrl ||
        parsed.web_url ||
        parsed.mwebUrl ||
        parsed.mweb_url ||
        parsed.payUrl ||
        parsed.pay_url ||
        payInfo.webUrl ||
        payInfo.web_url ||
        payInfo.mwebUrl ||
        payInfo.mweb_url ||
        payInfo.payUrl ||
        payInfo.pay_url ||
        '',
    ).trim();
    if (method.presentation === 'qr' && qrValue) return { type: 'qr', value: qrValue };
    if (method.presentation === 'qr' && paymentUrl) return { type: 'qr', value: paymentUrl };
    if (paymentUrl) return { type: 'redirect', url: paymentUrl };
  } catch {
    // Raw gateway payloads can be URLs, HTML, or QR content.
  }

  if (/^https?:\/\//i.test(body)) return { type: 'redirect', url: body };
  if (method.presentation === 'qr') return { type: 'qr', value: body };
  return { type: 'none' };
};
